// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const app = angular.module('CustomerSupport');
app.directive('fileAttachment', [
  '$timeout',
  ($timeout) => ({
    restrict: 'E',
    replace: true,
    templateUrl: 'customer_support/_file_attachment.html',

    scope: {
      attachmentChanged: '=',
    },

    link(scope, element, attributes, ctrl) {
      const maxSize = 1048576;
      scope.initAttachment = function () {
        scope.attachment = {
          fileAttached: false,
          tooBig: false,
          data: null,
          name: null,
          name_without_extension: null,
        };
        return scope.attachmentChanged(scope.attachment);
      };

      scope.removeAttachment = () => scope.initAttachment();
      scope.fileTooBig = (size) => size > maxSize;

      scope.$on('form-sent', () => scope.initAttachment());

      element.bind('change', function (changeEvent) {
        changeEvent.stopPropagation();
        const reader = new FileReader();
        const file = changeEvent.target.files[0];
        reader.onload = function (loadEvent) {
          scope.$apply(function () {
            scope.attachment = {
              fileAttached: true,
              tooBig: scope.fileTooBig(file.size),
              data: loadEvent.target.result,
              name: file.name,
              name_without_extension: file.name.split('.')[0],
              remove_attachment: t('remove_attachment', {
                attachment_name: file.name,
              }),
            };
            $timeout(() => scope.attachmentChanged(scope.attachment));
            changeEvent.target.value = '';
          });
        };
        return reader.readAsDataURL(file);
      });

      return scope.initAttachment();
    },
  }),
]);
